import { navigate } from '../router';
import type { RouteDef } from '../routes';
import styles from './screens.module.css';

/** Grade de cards que abrem telas (Home e hubs Financeiro/Relatórios/Perfil/Ajustes). */
export function ActionCards({ routes }: { routes: readonly RouteDef[] }) {
  return (
    <div className={styles.actions}>
      {routes.map((r) =>
        r.card ? (
          <button
            key={r.id}
            type="button"
            className={styles.actionCard}
            onClick={() => navigate(r.path)}
          >
            <span className={styles.actionIcon} aria-hidden="true">
              {r.card.icon}
            </span>
            <span className={styles.actionTitle}>{r.card.title}</span>
            <span className={styles.actionDesc}>{r.card.desc}</span>
          </button>
        ) : null,
      )}
    </div>
  );
}
